module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Allen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("Michael Allen")]), _vm._v(" is the John Dyer Trimble Professor of Systematic Theology and academic dean at Reformed Theological Seminary in Orlando, Florida. He is the author of numerous books, including "), _c('I', [_vm._v("Grounded in Heaven")]), _vm._v(", and the coeditor, with Scott R. Swain, of "), _c('I', [_vm._v("The Oxford Handbook of Reformed Theology")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/WbuI9/tc-custom/9781467451260.jpg?1744436099532",
      "alt": "This image is the cover for the book Grounded in Heaven"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Grounded in Heaven\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Eschatology and ethics are joined at the hip, says Michael Allen, and both need theocentric reorientation. In "), _c('i', [_vm._v("Grounded in Heaven ")]), _vm._v("Allen retrieves the traditional concept of the beatific vision and seeks to bring Christ back into the heart of our theology and our lives on earth.")]), _c('p', [_vm._v("Responding to the earthly-mindedness of much recent theology, Allen places his focus on God and the heavenly future while also appreciating ways in which the Reformed tradition provides a unique angle on broadly catholic concerns. Reaching back to classical ethics as well as its reformation by Calvin and other Reformed theologians, "), _c('i', [_vm._v("Grounded in Heaven ")]), _vm._v("offers a distinctly Protestant account of the ascetical calling to be heavenly-minded and to deny one’s self.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0